// extracted by mini-css-extract-plugin
export default {"main":"ShowMessage_main__Gtcsa","container":"ShowMessage_container__6VbRs"};